import { useContext } from 'react'
import { expandedNavItemsContext } from '../contexts'

// An easy way to access expanded side nav items
// Returns a tuple of [ expandedNavItem, setExpandedNavItem ]
function useExpandedNavItems() {
  return useContext(expandedNavItemsContext)
}

export default useExpandedNavItems
